import {Dialog} from "./common";
import {range} from "../helpers/column_names";

export const action = "add-chart";

const labels = webix.i18n.spreadsheet.labels;

function getTypes(){
	return [
		{id:"line", value:labels["line-chart"]},
		{id:"spline", value:labels["spline-chart"]},
		{id:"splineArea", value:labels["splinearea-chart"]},
		{id:"area", value:labels["area-chart"]},
		{id:"bar", value:labels["bar-chart"]},
		{id:"radar", value:labels["radar-chart"]},
		{id:"pie", value:labels["pie-chart"]},
		{id:"donut", value:labels["donut-chart"]}
	];
}

export class DialogBox extends Dialog{
	open(action){
		this.config = action.config;
		this.viewid = action.viewid;
		Dialog.prototype.open.apply(this, arguments);
	}
	$show(box, form){
		this.view.$handleSelection = function(st, end, a, b){
			form.elements.range.setValue(a+":"+b);
			return false;
		};

		form.clear();

		const values = this.config ? webix.extend(this.config.config, {
			range:this.config.data||""
		}, true) : {type:"line", range:this.view.getSelectedRange()};

		form.setValues(this.inValues(values));
		form.elements.range.focus();
	}
	$hide(){
		this.config = this.viewid = null;
		this.view.$handleSelection = null;
	}
	$init(){
		return {
			view: "ssheet-dialog",
			position:"center",
			width:460,
			head: labels["chart-config"],
			move: true,
			body:{ 
				view:"form",
				elements:[
					{ view: "richselect", name:"type", value:"line", label:labels["chart-type"], suggest:{
						view:  "ssheet-form-suggest",
						data:getTypes()
					}, on:{
						onChange: (v) => this.toggleFields(v)
					}},
					{ view: "checkbox", label:labels["stacked-chart"], name:"stacked"}, 
					{ view: "text", 	label:labels["chart-range"], name:"range"},
					{ view: "checkbox", label:labels["chart-col-axis"], labelWidth:180, name:"xAxis"},
					{ view: "checkbox", label:labels["chart-pie-text"], labelWidth:180, name:"pieInnerText", hidden:true},
					{ view: "checkbox", label:labels["chart-row-legend"], labelWidth:180, name:"legend"}
				],
				elementsConfig:{
					labelWidth:100
				}
			},
			on:{
				onSaveClick: () => this.okClick(),
				onHideClick: () => this.close(),
				onCancelClick: () => this.close()
			}
		};
	}
	okClick(){
		const form = this.$dialog.queryView("form");
		const config = this.outValues(form.getValues());

		if(this.checkRange(config.range)){
			if(!this.viewid)
				this.view.views.add(null,null,"chart", config.range, config);
			else if(form.isDirty())
				this.view.views.update(this.viewid, config.range, config);
			this.close();
		}
	}
	checkRange(text){
		if(text && range(text, this.view))
			return true;
		this.view.alert({text:labels["error-range"]});
	}
	outValues(values){
		if(values.stacked)
			values.type = "stacked"+values.type.charAt(0).toUpperCase()+values.type.substr(1);
		return values;
	}
	inValues(values){
		if(values.type.indexOf("stacked") !== -1)
			values.type = values.type.replace("stacked", "").toLowerCase();
		return values;
	}
	toggleFields(v){
		const f = this.$dialog.getBody().elements;
		
		if(v == "area" || v == "bar") f.stacked.show();
		else this.hideField(f.stacked);

		if(v == "pie" || v == "donut"){
			this.hideField(f.xAxis);
			f.pieInnerText.show();
			f.legend.define("label", labels["chart-col-legend"]);
		}
		else{
			f.xAxis.show();
			this.hideField(f.pieInnerText);
			f.legend.define("label", labels["chart-row-legend"]);
		}
		f.legend.refresh();
	}
	hideField(f){
		f.setValue(0);
		f.hide();
	}
}